import { useEffect, RefObject } from 'react';

type Event = MouseEvent | TouchEvent;

const useClickChatOutSide = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: Event | KeyboardEvent) => void,
) => {
  useEffect(() => {
    const escEvent = (event: KeyboardEvent) => {
      if (event.key === 'Escape') handler(event);
    };

    // 채팅 외부 영역 클릭 시 닫히는 기능은 제외
    // const listener = (event: Event) => {
    //   const el = ref?.current;
    //   if (!el || el.contains((event?.target as Node) || null)) {
    //     return;
    //   }
    //
    //   if ((event.target as HTMLElement).closest('[data-id="header"]')) return;
    //   handler(event);
    // };

    document.addEventListener('keydown', escEvent);
    // document.addEventListener('mousedown', listener);
    // document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('keydown', escEvent);
      // document.removeEventListener('mousedown', listener);
      // document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useClickChatOutSide;
